import React from 'react';
import HttpService from '../services/HttpService';

export const useApiState = (id: number, addCounter = false) => {

  const [apiEnabled, setApiEnabled] = React.useState<boolean>();
  const [error, setError] = React.useState();
  const [loadingApi, setLoadingApi] = React.useState<boolean>(true);

  const fetchData = async () => {
    try {
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/crm/apis/${id}`);
      setApiEnabled(response.data.is_enabled);
      (response.data.is_enabled && addCounter) && await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/crm/api/${id}`);
    } catch (error: any) {
      console.error(error);
      setError(error.data);
    }
    setLoadingApi(false);
  };

  React.useEffect(() => {
    fetchData();
  }, []);


  return {
    apiEnabled,
    error,
    loadingApi
  };

};
